import React from 'react';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
export function TestimonialsExtended() {
  const testimonials = [{
    initials: 'JM',
    name: 'Javier M.',
    role: 'Profesor de Funcional',
    text: 'Compré un sábado. El domingo por la noche tenía el mes de clases listo. Nunca más improviso.'
  }, {
    initials: 'LG',
    name: 'Laura G.',
    role: 'Profesora de Funcional',
    text: 'Tres alumnos de inicial que estaban estancados mejoraron su técnica desde el primer mes con el Tomo 2.'
  }, {
    initials: 'PR',
    name: 'Pablo R.',
    role: 'Profesor Independiente',
    text: 'Antes tardaba 1 hora armando una clase. Ahora son 5 minutos y la progresión está resuelta.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    role: 'Profesora de Funcional',
    text: 'El Bonus de Anatomía Visual cambió cómo corrijo a mis alumnos. Ahora sé exactamente qué decir y por qué.'
  }, {
    initials: 'DA',
    name: 'Diego A.',
    role: 'Entrenador Personal',
    text: 'El Bonus de Pre-Hab me salvó con un alumno con molestias de rodilla. Supe exactamente qué adaptar en cada ejercicio.'
  }, {
    initials: 'CR',
    name: 'Carolina R.',
    role: 'Profesora de Funcional',
    text: 'Los tomos por nivel cambiaron cómo manejo los grupos mixtos. Nunca más se para la clase por un alumno que no puede.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-50 border-y border-stone-200" data-id="element-16" data-mp="3kbc82tchhpqo">
      <div className="max-w-7xl mx-auto" data-id="element-17" data-mp="3gb0ozkzrrxhb">
        <div className="text-center mb-12" data-id="element-18" data-mp="3ubbeokpcf60w">
          <h2 className="text-3xl font-bold text-stone-900 mb-2" data-id="element-19" data-mp="3ua0f6x2xkkfl">
            Lo que dicen los profesores
          </h2>
          <p className="text-coral-500 font-bold flex justify-center items-center" data-id="element-20" data-mp="3pd1jia3mc5fa">
            4.9/5 <Star className="w-5 h-5 ml-1 fill-current" data-id="element-21" data-mp="1zxu03n6x1ji0" />
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-22" data-mp="1uzirtgw9rh1w">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm" data-id="element-23" data-mp="3v2b9lsf54rl5" data-mpi={i}>
              <div className="flex items-center gap-4 mb-4" data-id="element-24" data-mp="7w0sfwg00u89">
                <div className="w-12 h-12 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold text-lg" data-id="element-25" data-mp="7ug10fozdrem">
                  {t.initials}
                </div>
                <div data-id="element-26" data-mp="htf6jpeg96xe">
                  <p className="text-stone-900 font-bold" data-id="element-27" data-mp="hs45hxce2d9z">{t.name}</p>
                  <p className="text-stone-500 text-sm" data-id="element-28" data-mp="mrgqsdnm3cag">{t.role}</p>
                </div>
              </div>
              <p className="text-stone-700 italic" data-id="element-29" data-mp="rkjngunor1uv">"{t.text}"</p>
            </div>)}
        </div>
      </div>
    </section>;
}
export function Guarantee() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-30" data-mp="10lr9ad90ma82">
      <div className="bg-white border border-coral-200 rounded-3xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-31" data-mp="15iq4kz4f0n7u">
        <div className="absolute top-0 left-0 w-full h-2 bg-coral-500" data-id="element-32" data-mp="1fo953iomjaj4"></div>
        <ShieldCheck className="w-16 h-16 text-coral-500 mx-auto mb-6" data-id="element-33" data-mp="1ao3m0qwf6wcn" />
        <h2 className="text-3xl font-bold text-stone-900 mb-6" data-id="element-34" data-mp="15paa32ws7del">
          🛡️ Garantía 7 días sin preguntas
        </h2>
        <p className="text-lg text-stone-600 mb-8 leading-relaxed" data-id="element-35" data-mp="11o6vejqgzney">
          Abre los 12 Tomos. Revisa los 6 Bonus. Úsalos en tu clase. Si no es
          lo que esperabas → 100% de devolución. Sin preguntas. Sin
          formularios. Sin complicaciones.
        </p>
        <div className="inline-block bg-stone-100 text-stone-600 font-bold px-6 py-2 rounded-full text-sm tracking-wider" data-id="element-36" data-mp="1th7a7wqvcgzv">
          TASA DE DEVOLUCIONES MENOR AL 2%
        </div>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar el pago recibes un email con acceso inmediato a todos los archivos PDF. En menos de 5 minutos tienes todo en tu celular o computadora.'
  }, {
    q: '¿Sirve si soy profesor nuevo o si tengo experiencia?',
    a: 'Sí para los dos casos. El Tomo 1 arranca desde cero técnico. Los tomos avanzados llevan al límite a profesores con años de experiencia.'
  }, {
    q: '¿Los 6 Bonus están incluidos?',
    a: 'Sí. Los 6 Bonus están incluidos sin costo extra junto con los 12 Tomos. No hay que pagar nada aparte.'
  }, {
    q: '¿Qué diferencia hay con otros materiales que ya existen?',
    a: 'Funcional 360 es el único sistema de planificación para profesores de funcional con progresión real de 120 semanas y ejercicios graficados para usar en el campo directamente.'
  }, {
    q: '¿Sirve para grupos con niveles mezclados?',
    a: 'Sí. Los tomos están organizados por nivel, así que puedes tomar la progresión que corresponde a cada alumno y adaptar la carga en tiempo real sin frenar la clase.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tienes 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% del dinero. Sin preguntas ni formularios.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, además de transferencia bancaria.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-37" data-mp="wn92033apqrt">
      <h2 className="text-3xl font-bold text-stone-900 text-center mb-12" data-id="element-38" data-mp="8xy9ta00h4pa">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-4" data-id="element-39" data-mp="3z3j7lvsybum">
        {faqs.map((faq, i) => <details key={i} className="group bg-white rounded-xl border border-stone-200 shadow-sm [&_summary::-webkit-details-marker]:hidden" data-id="element-40" data-mp="40y08p3ydjtf" data-mpi={i}>
            <summary className="flex items-center justify-between p-6 cursor-pointer text-stone-900 font-bold" data-id="element-41" data-mp="dvgc4hjiwlob">
              {faq.q}
              <ChevronDown className="w-5 h-5 text-stone-400 group-open:rotate-180 transition-transform" data-id="element-42" data-mp="1pc6j42vrthiz" />
            </summary>
            <div className="px-6 pb-6 text-stone-600" data-id="element-43" data-mp="1wg5zp47tpexv">{faq.a}</div>
          </details>)}
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-stone-100 pt-16 pb-8 px-4 sm:px-6 lg:px-8 border-t border-stone-200 text-center" data-id="element-44" data-mp="21gagywgk2dp5">
      <div className="max-w-4xl mx-auto" data-id="element-45" data-mp="2bcnek5f81bp6">
        <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-46" data-mp="2bbc9m2a1hxwh">
          💪 FUNCIONAL 360
        </h3>
        <p className="text-stone-600 mb-8" data-id="element-47" data-mp="1dq7rmo40zlu8">
          El sistema de planificación N°1 para profesores de funcional.
        </p>

        <p className="text-coral-600 italic font-medium text-lg mb-12" data-id="element-48" data-mp="1ilvlhgtgd362">
          "Porque preparar una buena clase no debería costarte todas las noches
          de la semana."
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-stone-500 mb-12" data-id="element-49" data-mp="1sf42su1dpez2">
          <span className="flex items-center font-medium" data-id="element-50" data-mp="uwaz0ny3bns1">
            🏋️ FUNCIONAL 360™
          </span>
          <span className="hidden md:inline text-stone-300" data-id="element-51" data-mp="zv5htpw25cc5">|</span>
          <a href="mailto:contacto@funcional360.com.ar" className="hover:text-coral-500 transition-colors" data-id="element-52" data-mp="3d788kfpvajlr">
            📧 contacto@funcional360.com.ar
          </a>
          <span className="hidden md:inline text-stone-300" data-id="element-53" data-mp="345ih59vzjknz">|</span>
          <a href="#" className="hover:text-coral-500 transition-colors" data-id="element-54" data-mp="2z8rzii4j8h0g">
            📲 @funcional360.ar
          </a>
          <span className="hidden md:inline text-stone-300" data-id="element-55" data-mp="2u9p6jw1tu18u">|</span>
          <a href="#" className="hover:text-coral-500 transition-colors" data-id="element-56" data-mp="2phnlplqlf277">
            🌐 www.funcional360.ar
          </a>
        </div>

        <p className="text-xs text-stone-400" data-id="element-57" data-mp="2lh3pckdug2m4">
          © FUNCIONAL 360™ 2025 Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}